import APIRequest from '~/lib/api_request';

const JOB_STATUS_COLORS = {
  draft:    'primary',
  active:   'success',
  closed:   'danger',
  archived: 'secondary',
};

const getJobStatusColor = (status) => JOB_STATUS_COLORS[status?.toLowerCase()] || 'secondary';

const getLabelAndValueForOptions = (items, labelKey = 'name', valueKey = 'id') => items.map((item) => ({
  label: item[labelKey],
  value: item[valueKey],
}));

const checkIfJobLimitExceeded = async () => {
  try {
    const response = await APIRequest.get({
      resource: '/v1/jobs/jobs_limit',
    });

    const { body } = response;

    return body?.limit_exceeded;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export { getJobStatusColor, getLabelAndValueForOptions, checkIfJobLimitExceeded };
